/* eslint-disable @fullscript/one-translation-import-per-file */
import { aviary } from "@aviary/locales";
import { sharedUS } from "@shared/locales";
import { sharedUS as sharedUnAuthenticatedUS } from "@unauthenticated/shared/locales";

import { credentials } from "./credentials";
import { oauth } from "./oauth";

export const en = { aviary, oauth, credentials, ...sharedUS, ...sharedUnAuthenticatedUS };
